module.exports = __webpack_public_path__ + "static/img/医生发布-B@3x.a1ce4d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/bottom/医生发布-B@3x.png
// module id = 1254
// module chunks = 382